module.exports = __webpack_public_path__ + "static/6-33731ac683777c601bbc55b83fe41729.jpg";